import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import { space } from 'styled-system';

import type { DrawerEventProps } from '../../hooks/drawer';
import { useOpenDrawer } from '../../hooks/drawer';
import type { Color } from '../../theme/colors/types';
import { cursor } from '../../theme/system-utilities';
import { Button } from '../Button';
import Icon from '../Icon';

interface DrawerTriggerProps extends Omit<DrawerEventProps, 'open'> {
  ariaLabel?: string;
  size?: number;
  fill?: Color;
  borderRadius?: string;
  onTrackingClick?: () => void;
}

const INFO_ICON_SIZE = 24;

const BareButton = styled(Button)<any>`
  ${space};
  ${cursor};
`;

const bareButtonStyles: ComponentProps<typeof BareButton> = {
  p: 'sp_0',
  cursor: 'pointer',
  kind: 'bare',
};

const DrawerTrigger = ({
  ariaLabel,
  fill,
  size = INFO_ICON_SIZE,
  borderRadius,
  onTrackingClick,
  ...props
}: DrawerTriggerProps) => {
  const openDrawer = useOpenDrawer(props);

  const onClick = () => {
    onTrackingClick?.();
    openDrawer();
  };

  return (
    <BareButton
      data-testid="drawer-trigger"
      {...bareButtonStyles}
      {...(borderRadius ? { borderRadius } : {})}
      {...props}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <Icon name="info" size={size} {...(fill ? { fill } : {})} />
    </BareButton>
  );
};

export default DrawerTrigger;
